<template>
  <div class="bg-lightGray" :class="[width, barBg]">
    <div class="h-6 bg-brandRed" :class="[height, progressColor]" :style="`width:${progress}%;`" />
  </div>
</template>
<script>
export default {
  name: 'ProgressBar',
  props: {
    progressColor: {
      type: String,
      required: false,
      default: 'bg-brandRed',
    },
    barBg: {
      type: String,
      required: false,
      default: 'bg-lightGray',    
    },
    progress: {
      type: Number,
      default: 0,
    },
    width: {
      type: String,
      default: 'w-52',
    },
    height: {
      type: String,
      default: 'h-1',
    },
  },
}
</script>
